export const vendors = (state = [], action) => {
  if (action.type === 'FETCH_VENDORS') {
    return action.payload;
  }
  if (action.type === 'CLEAR_VENDORS') {
    return [];
  }
  return state;
};

export const vendor = (state = {}, action) => {
  if (action.type === 'FETCH_VENDOR') {
    return action.payload;
  }
  if (action.type === 'CLEAR_VENDOR') {
    return {};
  }
  return state;
};

export const vendorIds = (state = [], action) => {
  if (action.type === 'FETCH_VENDOR_IDS') {
    return action.payload;
  }
  if (action.type === 'CLEAR_VENDOR_IDS') {
    return [];
  }
  return state;
};
